<template>
  <el-dialog
  id="dialog"
    :visible.sync="show"
    :width="width"
    :modal="false"
    :close-on-click-modal="false"
    @close="cancle"
  >
    <div
      style="
        text-align: left;
        font-weight: 800;
        font-size: 20px;
        color: #000;
        margin-bottom: 5px;
      "
    >
      <!-- 在线申请试用产品 -->
      {{ title }}
    </div>
    <div
      style="
        text-align: left;
        color: #666666;
        font-weight: 500;
        margin-bottom: 20px;
      "
    >
      请填写您的基本诉求，提交后我们会尽快联系您！
    </div>
    <el-form
      size="small"
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
    >
      <el-form-item label="试用产品">
        <el-input
          v-model="form.productName"
          placeholder="请输入您要试用的产品或想了解的内容"
          :disabled="form.productName != '' && isProduc"
        ></el-input>
      </el-form-item>
      <el-form-item label="您的姓名" prop="askerName">
        <el-input
          v-model="form.askerName"
          placeholder="请输入您的姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="askerPhone">
        <el-input
          v-model="form.askerPhone"
          placeholder="请输入您的手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input
          v-model="form.askerEmail"
          placeholder="请输入您的邮箱"
        ></el-input>
      </el-form-item>
      <el-form-item label="公司/单位" prop="companyName">
        <el-input
          v-model="form.companyName"
          placeholder="请输入您的公司/单位"
        ></el-input>
      </el-form-item>
      <el-form-item label="重点需求描述" prop="questionDesp">
        <el-input
          type="textarea"
          :rows="5"
          v-model="form.questionDesp"
          placeholder="请输入您的重点需求描述"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <div>
          <div
            style="
              font-size: 10px;
              color: #999999;
              line-height: 15px;
              margin: 0 0 10px 0;
            "
          >
            <input
            v-model="checked"
              style="
                width: 14px;
                height: 12px;
                margin-right: 7px;
                position: relative;
                top: 2px;
              "
              type="checkbox"
              name=""
              
            />
            <div style="display: inline-block;color: #000;font-size: 13px;">
              我已阅读并同意 <span style="color: #d7000f">《用户协议》</span>
              <span style="color: #d7000f">《隐私协议》</span>
            </div>
          </div>
          <el-button
            style="width: 100%; text-align: center; margin: 0 auto"
            type="primary"
            @click="handleSubmitClick"
            >提交</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { addConsult } from "@/api/consult";
export default {
  data() {
    return {
      show: false,
      checked:false,
      form: {
        productId: undefined,
        productName: undefined,
        askerName: undefined,
        askerPhone: undefined,
        askerEmail: undefined,
        questionDesp: undefined,
        companyName: undefined,
      },
      rules: {
        productName: [
          { required: true, message: "请输入产品", trigger: "blur" },
        ],
        askerName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        askerPhone: [
          { required: true, message: "请输入电话", trigger: "blur" },
        ],
        askerEmail: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        questionDesp: [
          { required: true, message: "请输入重点需求描述", trigger: "blur" },
        ],
        companyName: [
          { required: true, message: "请输入公司/单位", trigger: "blur" },
        ],
      },
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: String,
    },
    productName: {
      type: String,
    },
    isProduc: {
      type: Boolean,
    },
    title: {
      type: String,
      default: "产品咨询",
    },
  },
  computed: {
    width() {
      return this.$store.state.app.device == "desktop"
        ? "440px"
        : `${document.body.clientWidth - 10}px`;
    },
  },
  mounted() {
    this.show = this.dialogVisible;
    this.$set(this.form, "productId", this.productId);
    this.$set(this.form, "productName", this.productName);
  },
  methods: {
    handleSubmitClick() {
      if (!this.checked) {
        this.$message.error("请阅读并同意用户协议和隐私协议");
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          addConsult(this.form).then((res) => {
            if (res.code === 0) {
              this.$message.success("提交成功");
              this.show = false;
            }
          });
        }
      });
    },
    cancle() {
      this.$emit("cancel", false);
    },
  },
  watch: {
    dialogVisible(data) {
      this.show = data;
    },
    productName(data) {
      this.shoform.productName = data;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ #dialog{
  z-index: 99000 !important;
}
/deep/.el-dialog__wrapper {
  background: rgba(0, 0, 0, 0.50) !important;
}
/deep/.el-form-item > .el-form-item__label {
  text-align: left !important;
}
/deep/.el-form-item > .el-form-item__content {
  margin-left: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ConsultDialog.vue